var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.sessionExpirationTime ? _c('Vidle', {
    attrs: {
      "loop": false,
      "duration": _vm.sessionExpirationTime
    },
    on: {
      "idle": _vm.showModal
    }
  }) : _vm._e(), _vm.showVidleModal ? _c('div', {
    staticClass: "v-idle-modal"
  }, [_c('div', {
    staticClass: "v-idle-modal-body"
  }, [_c('p', {
    staticClass: "body-heading"
  }, [_vm._v("Your session has expired due to inactivity")]), _c('p', {
    staticClass: "body-sub-heading"
  }, [_vm._v("Please login to continue")]), _c('div', {
    staticClass: "v-idle-modal-footer"
  }, [_c('button', {
    staticClass: "modal-ok-btn",
    on: {
      "click": _vm.onIdle
    }
  }, [_vm._v("OK")])])])]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }